import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import deTranslation from './lang/de.json';
import deTOS from './temp_documents/tos.json';
import deReturnPolicy from './temp_documents/return_policy.json';
import deDataProtection from './temp_documents/data_protection.json';
import Sanitizer from './PostProcessor';

export const DocumentIdentifier = {
  TermsOfService: 'tos',
  ReturnPolicy: 'return_policy',
  DataProtection: 'data_protection'
};

const resources = {
  de: {
    translation: {
      ...deTranslation
    }
  }
};

const loadTermsOfService = () => {
  var promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ ...deTOS });
    }, 500);
  });
  return promise;

  // TODO: Re-enable once we have the tos translation file hosted externally.
  //return Axios.get('...');
};

const loadReturnPolicy = () => {
  var promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ ...deReturnPolicy });
    }, 500);
  });
  return promise;

  // TODO: Re-enable once we have the return policy translation file hosted externally.
  //return Axios.get('...');
};

const loadDataProtection = () => {
  var promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ ...deDataProtection });
    }, 500);
  });
  return promise;

  // TODO: Re-enable once we have the return policy translation file hosted externally.
  //return Axios.get('...');
};

const i18nProvider = () => {
  var i18n = i18next
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(Sanitizer as any)
    .init({
      resources,
      lng: 'de',
      fallbackLng: 'de',
      interpolation: {
        // TODO: DO NOT set escapeValue globally to false as this opens the app to XSS
        // Ticket created: PKD-566
        escapeValue: false
      },
      postProcess: ['Sanitizer']
    });

  return i18n;
};

export default i18nProvider();

export var waitForTermsOfService = new Promise<void>((resolve, reject) => {
  loadTermsOfService()
    .then((response: any) => {
      i18next.addResourceBundle('de', DocumentIdentifier.TermsOfService, { ...response }, true);
      resolve();
    })
    .catch((error: any) => {
      console.error('Error loading tos file!');
      console.error(error);
      reject();
    });
});

export var waitForReturnPolicy = new Promise<void>((resolve, reject) => {
  loadReturnPolicy()
    .then((response: any) => {
      i18next.addResourceBundle('de', DocumentIdentifier.ReturnPolicy, { ...response }, true);
      resolve();
    })
    .catch((error: any) => {
      console.error('Error loading return policy file!');
      console.error(error);
      reject();
    });
});

export var waitForDataProtection = new Promise<void>((resolve, reject) => {
  loadDataProtection()
    .then((response: any) => {
      i18next.addResourceBundle('de', DocumentIdentifier.DataProtection, { ...response }, true);
      resolve();
    })
    .catch((error: any) => {
      console.error('Error loading data protection file!');
      console.error(error);
      reject();
    });
});
